import AxiosHelper from '../api/AxiosHelper';

// LicenseError renders message.title / message.description, so a message is
// always an object even when the server sends only a plain string.
const fallback = {
  title: 'License check failed',
  description: 'Your software license could not be verified.'
};

const checkLicense = async () => {
  try {
    const res = await AxiosHelper.verifyLicense();
    if (res.status === 200) return { valid: true };

    return { valid: false, message: fallback };
  } catch (err) {
    // No response at all means the server is unreachable rather than the
    // license being bad, so the app still loads. err.response is undefined on
    // this branch and must not be read.
    if (!err?.response) return { valid: true };

    const { code, msg, expiresAt } = err.response.data || {};
    return {
      valid: false,
      code,
      message: msg?.title ? msg : fallback,
      expiresAt
    };
  }
};

export default checkLicense;
